<template lang="pug">

    .ui.five.steps
        .step(v-bind:class='{active: activeStep === 1, completed: activeStep > 1}', @click='goToStep(1)')
            i.hand.point.up.icon
            .content
                .title Produkttyp wählen
        .step(v-bind:class='{disabled: activeStep < 2, active: activeStep === 2, completed: activeStep > 2}', @click='goToStep(2)')
            i.swatchbook.icon
            .content
                .title Produktangaben
        .step(v-bind:class='{disabled: activeStep < 3, active: activeStep === 3, completed: activeStep > 3}', @click='goToStep(3)')
            i.info.circle.icon
            .content
                .title Zusätzliche Angaben
        .step(v-bind:class='{disabled: activeStep < 4, active: activeStep === 4, completed: activeStep > 4}', @click='goToStep(4)')
            i.clock.icon
            .content
                .title Termine
        .step(v-bind:class='{disabled: activeStep < 5, active: activeStep === 5}', @click='goToStep(5)')
            i.truck.packing.icon
            .content
                .title Lieferadressen

</template>

<script>

    export default {

        props: {

            activeStep: {
                type: Number,
                required: true
            }

        },

        methods: {

            goToStep(step) {
                if (step >= this.activeStep) return
                const key = this.$route.params.key
                const name = step === 1 ? 'products/create/step1' : `products/create/step${step}`
                this.$router.push({ name, params: { key } })
            }

        }

    }

</script>

<style scoped>
.step.completed {
    cursor: pointer;
}
</style>
